import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import LoansPage from "@/pages/LoansPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminPanel from "@/components/AdminPanel";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import usePageTracking from "@/hooks/usePageTracking";
import LeadMagnetPopup from "@/components/LeadMagnetPopup";

function AppContent() {
  usePageTracking();
  const location = useLocation();
  
  return (
    <>
      <Routes>
            {/* Public Routes with Header and Footer */}
            <Route path="/" element={
              <>
                <Header />
                <Home />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/services" element={
              <>
                <Header />
                <ServicesPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/loans" element={
              <>
                <Header />
                <LoansPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <AboutPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <ContactPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            
            {/* Legal Pages */}
            <Route path="/terms" element={
              <>
                <Header />
                <TermsPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/disclaimer" element={
              <>
                <Header />
                <DisclaimerPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            <Route path="/privacy" element={
              <>
                <Header />
                <PrivacyPage />
                <Footer />
                <WhatsAppFloat />
              </>
            } />
            
            {/* Admin Panel (No Header/Footer) */}
            <Route path="/admin" element={<AdminPanel />} />
            
            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
      </Routes>
      {location.pathname !== '/admin' && <LeadMagnetPopup />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
